var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPreviousArrow = function SvgPreviousArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 25,
    height: 25,
    rx: 4,
    transform: "rotate(180 25 25)",
    fill: "#F3F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5289 16.5286C10.2686 16.7889 10.2686 17.211 10.5289 17.4714C10.7893 17.7317 11.2114 17.7317 11.4717 17.4714L15.4717 13.4714C15.7241 13.219 15.7329 12.8126 15.4918 12.5495L11.8251 8.54948C11.5763 8.27806 11.1546 8.25973 10.8832 8.50852C10.6118 8.75732 10.5934 9.17903 10.8422 9.45044L14.0776 12.9799L10.5289 16.5286Z",
    fill: "#6C757D"
  })));
};
export default SvgPreviousArrow;